import qs from 'qs'

const nativeConsole =
  typeof globalThis !== 'undefined' && globalThis.console
    ? globalThis.console
    : {
        error: () => void 0,
        info: () => void 0,
        debug: () => void 0,
      }

const getQuery = () => {
  if (typeof window === 'undefined') return {}
  return qs.parse(window.location.search, { ignoreQueryPrefix: true }) || {}
}

export const logger = {
  get isProd() {
    return process.env.NODE_ENV === 'production'
  },
  get isTestMode() {
    return process.env.NODE_ENV === 'test'
  },
  get isDebugMode() {
    const q = getQuery()
    return q?.debug === 'true'
  },
  error(...args) {
    if (this.isTestMode) return
    nativeConsole.error(...args)
  },
  log(message) {
    if (this.isTestMode) return
    if (this.isProd) nativeConsole.info(String(message))
  },
  debug(message) {
    if (this.isTestMode) return
    if (this.isProd && this.isDebugMode) {
      nativeConsole.debug(String(message))
    }
  },
}
